const product = JSON.parse(sessionStorage.getItem('semprebem:product'))

function qtdDependencies () {
  const dependent = product.plan.counterDependent
  if (dependent > 0) {
    const lblDependente = (dependent === 1) ? 'Dependente' : 'Dependentes'
    return `${product.plan.name} (Titular + ${dependent} ${lblDependente})`
  }
  return `${product.plan.name}`
}

const listOfConditions = [
  {
    id: 1,
    text: 'Estou de acordo com os <a href="https://static.ciclic.com.br/files/paguemenos/regulamento_paguemenos.pdf" target="_blank">Termos e Condições do "Sempre Bem Ouro +"</a> e a <a href="http://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/L13709.htm" target="_blank">Lei Geral de Proteção de Dados</a>.',
    required: true
  }
]

if (process.env.VUE_APP_JOURNEY_NAME !== 'funcionario') {
  listOfConditions.push({
    id: 2,
    text: 'Confirmo que estou ciente do período de <span>permanência mínima de 3 meses</span>. Caso eu cancele o plano antes desse período, sujeito a multa de R$ 60,00.',
    required: true
  })
}

const productBasicData = {
  name: 'Saúde Protegida',
  alias: 'saude',
  aliasEN: 'health',
  api: {
    path: product.api,
    version: 'v1'
  },
  recurrent: true,
  hasInsuranceDetails: false,
  allowChangeAddress: true,
  infoInsurance: [
    {
      type: 'text',
      label: 'Plano',
      icon: 'health',
      text: qtdDependencies()
    },
    {
      type: 'text',
      label: 'Vigência',
      icon: 'calendar',
      text: 'Plano mensal (Sem carência)'
    }
  ],
  listOfConditions,
  payment: [
    {
      section: 'root',
      items: [{
        listPets: []
      }]
    },
    {
      section: 'payment',
      items: [
        {
          installments: 'payment/getPaymentParcels',
          byRef: true
        }
      ]
    }
  ]
}

export { productBasicData }
